import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  CreateBuildingActions as Actions,
  CreateBuildingRequestAction as RequestAction,
} from 'store/ducks/buildings';

export function* createBuildingRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, 'buildings', postData);
    onSuccess && onSuccess();
    notify('success', 'Prédio criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
